import { PayloadAction } from "@reduxjs/toolkit";

import { BrandsState } from '../../types';

export const resetDeletingStatus = (
  state: BrandsState,
  action: PayloadAction<BrandsState['favouriteBrands']['deletingStatus']>
) => {
  state.favouriteBrands.deletingStatus = action.payload;
};
